import { render, staticRenderFns } from "./courserVideos.vue?vue&type=template&id=02962098"
import script from "./courserVideos.vue?vue&type=script&lang=js"
export * from "./courserVideos.vue?vue&type=script&lang=js"
import style0 from "./courserVideos.vue?vue&type=style&index=0&id=02962098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports